import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';
import { RootState } from '../../domain/models/RootState';

export const getAllHousekeys = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>(
  'Housekeys/getAllHousekeys',
  async ({ filter, pagination }: any, thunkAPI) => {
    try {
      const { auth }: RootState = thunkAPI.getState();
      return await API.getAllHousekeys({ filter, pagination }, auth.token);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const updateHousekey = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>('Housekeys/updateHousekey', async ({ values, text }: any, thunkAPI) => {
  try {
    const { auth }: RootState = thunkAPI.getState();
    const res = await API.updateHousekey(values, auth.token);
    Swal.fire({
      icon: 'success',
      title: `${text || 'Editado'} con exito`,
    });
    return res.data;
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: `Hubo un error al editar los datos`,
      text: 'intenta de nuevo',
    });
    throw error;
  }
});

export const createHousekey = createAsyncThunk<
  any,
  any,
  {
    state: RootState;
  }
>('Housekeys/createHousekey', async (housekey: any, thunkAPI) => {
  try {
    const { auth }: RootState = thunkAPI.getState();
    const res = await API.createHousekey(housekey, auth.token);
    if (res.status === 201) {
      Swal.fire('Correcto', 'la llave se agregó correctamente', 'success');
      return res.data;
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Hubo un error al crear la llave',
      text: 'Por favor, intenta de nuevo',
    });
    throw error;
  }
});
